export default {
  data() {
    return {
      progress: {},
    };
  },
  methods: {
    startProgress(name) {
      this.progress[name].visible = true;

      setTimeout(() => {
        this.progress[name].progress = this.progress[name].initialLoad;
      }, 250);

      this.progress[name].interval = setInterval(() => {
        if (this.progress[name].progress < 95) {
          this.progress[name].progress =
            this.progress[name].progress + this.progress[name].increment;
        }
      }, 250);
    },
    endProgress(name) {
      this.progress[name].progress = 100;
      clearInterval(this.progress[name].interval);
    },
    closeProgress(name) {
      this.progress[name].visible = false;
      this.progress[name].progress = 0; // Reset progress when closing
      clearInterval(this.progress[name].interval);
    },
    registerLoader(name, increment = 2, initialLoad = 20) {
      this.$set(this.progress, name, {
        progress: 0,
        visible: false,
        increment: increment,
        initialLoad: 20,
      });
    },
  },
};
